import React from "react";
import { Container } from "react-bootstrap";

const MapSection = () => {
    return (
        <section className="section map-section">
            <Container>

                {/* Common Heading */}
                <div className="section-title fade-up text-center">
                    <h2>Find Us on Map</h2>
                    <p>
                        Connecting Hindustan Agro Life with farmers, partners, and
                        agricultural communities across regions.
                    </p>
                </div>

                {/* Full Width Map */}
                <div className="map-wrapper fade-up">
                    <iframe
                        title="Hindustan Agro Life Location"
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2828.394822236862!2d75.02640347532372!3d23.349068178946208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDIwJzU2LjciTiA3NcKwMDEnNDQuMyJF!5e1!3m2!1sen!2sin!4v1770724414361!5m2!1sen!2sin"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

            </Container>
        </section>
    );
};

export default MapSection;
